<template>
  <div class="row">
    <div class="col-sm-12">
      <createVendor />
    </div>
  </div>
</template>

<script setup>
import createVendor from '@/components/application/vendors/create_vendor/createVendor.vue';
</script>

<style></style>
